import FormOutlined from "@ant-design/icons/lib/icons/FormOutlined";
import HistoryOutlined from "@ant-design/icons/lib/icons/HistoryOutlined";
import { Tabs, TabsProps } from "antd";
import { useState } from "react";
import InventoryCheckHistory from "./InventoryCheckHistory";
import InventoryAuditForm from "./InventoryAuditForm";

function InventoryAudit() {
  const [activeTab, setActiveTab] = useState<string>("1");

  const onChange = (key: string) => {
    setActiveTab(key);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      icon: <HistoryOutlined />,
      label: "Lịch sử kiểm kê",
      children: <InventoryCheckHistory activeTab={activeTab} />,
    },
    {
      key: "2",
      label: "Form kiểm kê",
      icon: <FormOutlined />,
      children: <InventoryAuditForm setActiveTab={setActiveTab} />,
    },
  ];

  return (
    <div className="w-100 h-100">
      <Tabs
        defaultActiveKey={activeTab}
        activeKey={activeTab}
        items={items}
        onChange={onChange}
        style={{ height: "100%" }}
      />
    </div>
  );
}
export default InventoryAudit;
